import React from 'react'
import { IData } from '../../../interfaces/table'

import {
  Container,
  Title,
  Subtitle,
} from './styles'

const TextWithDescription = ({ value }: IData) => (
  <Container>
    <Title>{value.title}</Title>
    <Subtitle>{value.subtitle}</Subtitle>
  </Container>
)

export default TextWithDescription
